// SPDX-License-Identifier: Apache-2.0

import PerunMessage from "./PerunMessage";
import { jsonMember, jsonObject } from "typedjson";
import { MessageType, MessageTypeName } from "./messageTypes";

@jsonObject
export default class SignSteData extends PerunMessage {
  @jsonMember(String) address: string;
  @jsonMember(String) data: string;

  constructor(address: string, data: string) {
    super();
    this.address = address;
    this.data = data;
  }

  messageType(): MessageType {
    return SignSteData;
  }

  messageTypeName(): MessageTypeName {
    return "SignSteData";
  }
}
